import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const getDatasetVersionMetricsTE = <E = CF.API.ApiError>(
  {
    appId,
    userId,
    datasetId,
    datasetVersionId,
    typeId,
  }: {
    appId: string;
    userId: string;
    datasetId: string;
    datasetVersionId: string;
    typeId?: number;
  },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Datasets.FetchDatasetVersionMetricsResponse> =>
  fetchTE<CF.API.Datasets.FetchDatasetVersionMetricsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/apps/${appId}/datasets/${datasetId}/versions/${datasetVersionId}/metrics${
        typeId !== undefined ? `?types=${typeId}` : ''
      }`,
      method: 'GET',
    },
    onRejected,
  );
